export { default } from "./VideoTranscript";
